export function formattedTime(milliseconds: number | string | undefined): string {
  if (!milliseconds) {
    return "-- : -- : ---";
  }

  const date = new Date(Number(milliseconds));
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();
  const mlSeconds = date.getUTCMilliseconds();

  return [
    minutes.toString().padStart(2, "0"),
    seconds.toString().padStart(2, "0"),
    mlSeconds.toString().padStart(3, "0"),
  ].join(":");
}

// Formats a stored challenge score for display. Time-trial scores (numeric ms)
// are rendered as mm:ss:mmm; point-based scores that aren't a numeric time are
// returned unchanged, and empty values render a short placeholder.
export function formatScore(points: number | string | undefined): string {
  if (!points) return "---";
  if (Number.isNaN(Number(points))) return String(points);
  return formattedTime(points);
}
